export default __webpack_public_path__ + "static/b-pill-modal-default-67fa3d7323c7d781ebf7730c9fb6aab9.png";